module.exports = __webpack_public_path__ + "static/img/73.94aba9a2.png";